import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const TIMETABLE = {
  key: ROUTES.TIMETABLE.ROOT,
  label: TITLES[ROUTES.TIMETABLE.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.TIMETABLE.APARTMENTS,
      label: TITLES[ROUTES.TIMETABLE.APARTMENTS],
      environment: [DEV, STAGE, PROD],
      children: [
        {
          key: ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
          label: TITLES[ROUTES.TIMETABLE.APARTMENTS_PROJECTS],
          environment: [DEV, STAGE, PROD],
        },
        {
          key: ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
          label: TITLES[ROUTES.TIMETABLE.APARTMENTS_MANAGERS],
          environment: [DEV, STAGE, PROD],
        },
      ],
    },
  ],
};
